import app from 'flarum/forum/app';
import NotificationSettingsPage from './components/NotificationSettingsPage';
import addHeaderButton from './extend/addHeaderButton';
import addSettingsLinks from './extend/addSettingsLinks';
import adjustNotificationGrid from './extend/adjustNotificationGrid';

app.initializers.add('happydigital-notification-settings', () => {
  // Name must match Extend\Frontend::route() in extend.php.
  app.routes.happyNotifySettings = { path: '/notifications/settings', component: NotificationSettingsPage };

  addHeaderButton();
  addSettingsLinks();
  adjustNotificationGrid();
});
